import { useCallback, useEffect, useState } from "react";
import { fetchOrgLocations } from "@/lib/locations/fetchOrgLocations";
import { supabase } from "@/lib/supabase";
import type { AdsFeedImportLocationRow } from "@/components/ads-assistant/adsFeedImportSectionTypes";

/** Org locations for Ads Assistant (feed import, index filter, etc.). */
export function useAdsAssistantOrgLocations(scopedOrgId: string | null) {
  const [locations, setLocations] = useState<AdsFeedImportLocationRow[]>([]);
  const [locationsLoaded, setLocationsLoaded] = useState(false);

  const reload = useCallback(async () => {
    if (!scopedOrgId || !supabase) {
      setLocations([]);
      setLocationsLoaded(true);
      return;
    }
    setLocationsLoaded(false);
    const { data, error } = await fetchOrgLocations(supabase, scopedOrgId);
    if (error) setLocations([]);
    else setLocations(data as AdsFeedImportLocationRow[]);
    setLocationsLoaded(true);
  }, [scopedOrgId]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { locations, locationsLoaded, reloadLocations: reload };
}
